// Slider Setup //
function setupSlider() {
    $('.slider--container .slider.slick-initialized').slick('unslick');

    var $sliderContainer = $('.slider--container');

    $sliderContainer.each(function () {
        var $container = $(this),
            $slider = $container.find('.slider'),
            infinite = false,
            fade = false,
            autoPlay = false,
            arrows = false,
            dots = false;

        // Infinite //
        if ($container.data('infinite')) {
            infinite = true;
        }

        // Fade //
        if ($container.data('fade')) {
            fade = true;
        }

        // Auto //
        if ($container.data('auto')) {
            autoPlay = true;
        }

        // Pagination
        if ($container.data('dots')) {
            dots = true;
        }

        // Arrows
        if ($container.data('arrows')) {
            arrows = true;
        }

        $slider
            .not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: arrows,
            infinite: infinite,
            fade: fade,
            autoplay: autoPlay,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            rows: 0,
            dots: dots,
        });
    });
}

// Prevent focus from being applied to email link in fancybox
$.fancybox.defaults.autoFocus = false;

// Collapse items that are too wide for body
function collapseElementsByWidth()
{
    if(!$body){
        var $body = $('body');
    }
    $('.collapse-by-width').each(function() {
        var $container = $(this);

        // Remove collapsed class so we can measure
        $container.removeClass('collapsed-view');

        var scrollWidth = $container.get(0).scrollWidth;

        if (scrollWidth > $body.outerWidth(true)) {
            $container.addClass('collapsed-view');
        }
    });
}

function toggleMenu(){

    var $button = $('.js-toggle--menu');
    var $navigation = $('#main-nav');
    var $pageBanner = $('.block--page-banner');



    if ($pageBanner) {
        // subtract 10 to account for 5px top offset
        $navigation.css('minHeight', $pageBanner.outerHeight() - 5);
    }

    if ($navigation.hasClass('open')) {
        $button.removeClass('open');
        $navigation.removeClass('open');
    } else {
        $button.addClass('open');
        $navigation.addClass('open');
    }
}

// When the window has finished loading create our google map below
// google.maps.event.addDomListener(window, 'load', init);

function googleMapsInit() {
    // Basic options for a simple Google Map
    // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
    var mapOptions = {
        // How zoomed in you want the map to start at (always required)
        zoom: 16,

        // The latitude and longitude to center the map (always required)
        center: new google.maps.LatLng(-28.027551, 153.431919),

        // How you would like to style the map.
        // This is where you would paste any style found on Snazzy Maps.
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.business",
                "stylers": [
                    {
                        "color": "#716d5e"
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ]
    };

    // Get the HTML DOM element that will contain your map
    // We are using a div with id="map" seen below in the <body>
    var mapElement = document.getElementById('map');

    // Create the Google Map using our element and options defined above
    var map = new google.maps.Map(mapElement, mapOptions);

    // Let's also add a marker while we're at it
    var marker = new google.maps.Marker({
        position: new google.maps.LatLng(-28.027551, 153.431919),
        map: map,
        title: 'Snazzy!'
    });
}

$(function() {
    var $body = $('body');

    // CSS class to hide elements before page has finished loading
    setTimeout(function () {
        $('.preload').removeClass('preload');
    }, 500);

    //setup Map

    if($('#map').length > 0) {
        googleMapsInit();
    }

    // Setup Slider //
    setupSlider();

    // Collapse by width
    collapseElementsByWidth();

    // Resize throttle
    var resizeThrottle;
    var previousWidth = $(window).outerWidth();

    $(window).resize(function() {
        if (resizeThrottle) {
            clearTimeout(resizeThrottle);
        }

        resizeThrottle = setTimeout(function() {

            // if(previousWidth != $(window).outerWidth()) {
            //     previousWidth = $(window).outerWidth();
            //
            //     if($('.nav').hasClass('open')){
            //
            //         $('.nav.open').removeClass('open');
            //         $('.nav-button').removeClass('nav-open');
            //         toggleBlockScrolling();
            //
            //         return;
            //     }
            // } else {
            //     return
            // }

            collapseElementsByWidth();

            if($('.js-toggle--menu').hasClass('open')) {
                toggleMenu();
            }
        }, 50);
    });

    // Click events

    $body
        .on('click', '.js-toggle--menu', function() {
            toggleMenu();
        })
        .on('click', '.js-toggle--dropdown', function(){
            $(this).closest('.has-dropdown').toggleClass('open');
        })
    ;
});